import { daysInMonth } from './tokens/month';
export function prevDate(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() - amount);
}
export function nextDate(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + amount);
}
export function prevMonth(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var dateOfMonth = date.getDate();
  var newDate = new Date(date);
  newDate.setDate(1);
  newDate.setMonth(newDate.getMonth() - amount);
  var maxDate = daysInMonth(newDate.getFullYear(), newDate.getMonth());
  newDate.setDate(Math.min(dateOfMonth, maxDate));
  return newDate;
}
export function nextMonth(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return prevMonth(date, -amount);
}
export function prevYear(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return prevMonth(date, amount * 12);
}
export function nextYear(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return prevYear(date, -amount);
}
export function sortDate(dateList) {
  return dateList.sort(function (a, b) {
    return a.getTime() - b.getTime();
  });
}